import { render, staticRenderFns } from "./Violation.vue?vue&type=template&id=0bd066f2&"
import script from "./Violation.vue?vue&type=script&lang=js&"
export * from "./Violation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/hemmelig/components/contract/Violation.vue
// module id = null
// module chunks = 